export default {
  namespaced: true,


  state: localStorage.getItem('fac-state') ? JSON.parse(localStorage.getItem('fac-state')).Login : {
    menuList: [
      {
        menuName: '静态数据',
        menuJoint: '',
        menuIcon: '',
        menuMuid: '1',
        a01MenuChildBeanList: [
          {
            menuName: '资产管理台账',
            menuMuid: '1-1',
            menuJoint: '/guide/static-info/property',
            menuIcon: '',
          },
          {
            menuName: '管理人员信息',
            menuMuid: '1-2',
            menuJoint: '/guide/static-info/staff-info',
            menuIcon: '',
          },
          {
            menuName: '供应商联系方式',
            menuMuid: '1-3',
            menuJoint: '/guide/static-info/supplier-contact',
            menuIcon: '',
          },
          {
            menuName: '维修工具台账',
            menuMuid: '1-4',
            menuJoint: '/guide/static-info/tool',
            menuIcon: '',
          },
          {
            menuName: 'OPL单点课',
            menuMuid: '1-5',
            menuJoint: '/guide/static-info/single-point',
            menuIcon: '',
          },
          {
            menuName: '设备备件卡',
            menuMuid: '1-6',
            menuJoint: '/guide/static-info/spare-parts',
            menuIcon: '',
          },
          {
            menuName: '预防维护标准',
            menuMuid: '1-7',
            menuJoint: '/guide/static-info/pre-maintain',
            menuIcon: '',
          },
          {
            menuName: '基础参数统计',
            menuMuid: '1-8',
            menuJoint: '/guide/static-info/params-statistics',
            menuIcon: '',
          },
        ],
      },
      {
        menuName: '中间数据',
        menuJoint: '',
        menuIcon: '',
        menuMuid: '2',
        a01MenuChildBeanList: [
          {
            menuName: '设备履历表',
            menuMuid: '2-1',
            menuJoint: '/guide/middle-info/resume',
            menuIcon: '',
          },
          {
            menuName: '点检记录表',
            menuMuid: '2-2',
            menuJoint: '/guide/middle-info/spot-check',
            menuIcon: '',
          },
          {
            menuName: '设备周检修计划表',
            menuMuid: '2-3',
            menuJoint: '/guide/middle-info/medium-service',
            menuIcon: '',
          },
          {
            menuName: '设备故障记录清单',
            menuMuid: '2-4',
            menuJoint: '/guide/middle-info/medium-malfunction',
            menuIcon: '',
          },
        ],
      },
      {
        menuName: '动态数据',
        menuJoint: '',
        menuIcon: '',
        menuMuid: '3',
        a01MenuChildBeanList: [
          {
            menuName: '维修申请单',
            menuMuid: '3-1',
            menuJoint: '/guide/active-info/maintenance-application',
            menuIcon: '',
          },
          {
            menuName: '维修记录台账',
            menuMuid: '3-2',
            menuJoint: '/guide/active-info/maintenance-record',
            menuIcon: '',
          },
          {
            menuName: '备件申请单',
            menuMuid: '3-3',
            menuJoint: '/guide/active-info/sparePart-application',
            menuIcon: '',
          },
          {
            menuName: '设备管理评价表',
            menuMuid: '3-4',
            menuJoint: '/guide/active-info/assessment',
            menuIcon: '',
          },
          {
            menuName: '设备TPM管理综合评价',
            menuMuid: '3-5',
            menuJoint: '/guide/active-info/comprehensive-assessment',
            menuIcon: '',
          },
        ],
      }
    ],
    userInfo: {}
  },

  mutations: {
    MENU_LIST(state, data) {
      state.menuList = data
    },
    USER_INFO(state, data) {
      state.userInfo = data
    },

  }
}